module.exports = __webpack_public_path__ + "img/icon_product11.fdb1ce24.png";